import * as tslib_1 from "tslib";
import HeaderContainer from './HeaderContainer';
import { observer } from 'mobx-react';
import { FileProviderView } from 'owa-filepicker-options-view';
import * as React from 'react';
var styles = require('./StorageAccountsListView.scss');
var StorageAccountsListView = /** @class */ (function (_super) {
    tslib_1.__extends(StorageAccountsListView, _super);
    function StorageAccountsListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StorageAccountsListView.prototype.render = function () {
        var _this = this;
        return (React.createElement(HeaderContainer, { className: styles.container, header: this.props.header },
            React.createElement("div", null, this.props.storageAccounts.map(function (storageAccount) {
                var removeHandler = _this.props.onRemoveHandler &&
                    (function () { return _this.props.onRemoveHandler(storageAccount); });
                return (React.createElement("div", { key: storageAccount.model.Id, className: styles.storageAccount },
                    React.createElement(FileProviderView, { providerType: storageAccount.type, providerName: storageAccount.name, displayText: storageAccount.model.AssociatedDataProviderAccountId, onRemoveClicked: removeHandler })));
            }))));
    };
    StorageAccountsListView = tslib_1.__decorate([
        observer
    ], StorageAccountsListView);
    return StorageAccountsListView;
}(React.Component));
export default StorageAccountsListView;
//# sourceMappingURL=StorageAccountsListView.js.map